import {Component, OnInit} from '@angular/core';
import {DutyCalendar} from '../google-data';
import {GoogleCalendarService} from '../google-calendar.service';

/** Relèves affichées sous le piquet en cours, par calendrier. */
const NEXT_COUNT = 4;

@Component({
    selector: 'mir-google-calendars-widget',
    templateUrl: './google-calendars-widget.component.html',
    styleUrls: ['./google-calendars-widget.component.css'],
    standalone: false
})
export class GoogleCalendarsWidgetComponent implements OnInit {
  duties: DutyCalendar[];

  constructor(private gService: GoogleCalendarService) {
  }

  ngOnInit(): void {
    this.gService.getDuties(NEXT_COUNT).subscribe({
      next: (duties: DutyCalendar[]) => this.duties = duties,
      // La liste reste vide : le widget disparaît du tableau de bord plutôt
      // que d'y afficher une erreur, le piquet n'étant pas une information
      // dont l'absence justifie d'alerter.
      error: () => this.duties = null
    });
  }

}
